import { Box, Button, Container, Grid, Typography } from '@mui/material'
import { SigninImg, SigninLogo } from 'app/signin/styles'
import Carousel from 'components/carousel'
import useNavigation from 'hooks/useNavigation'
import { listImages } from 'utils/catalogs'

export default function Message() {
  const { onNavigate } = useNavigation()

  const handleRedirect = () => {
    onNavigate('/login')
  }
  return (
    <Container>
      <Grid
        container
        paddingX={8}
        spacing={5}
        padding={0}
        justifyContent="center"
      >
        <Grid item md={5} paddingY={5}>
          <SigninLogo src="/images/logo.png" alt="logo" />
          <Box paddingTop={5} paddingRight={5}>
            <Typography variant="h2" paddingX="8px" paddingBottom={4}>
              Thank you!
            </Typography>
            <Typography variant="body1" paddingX="8px" paddingBottom={4}>
              We’ll contact you
            </Typography>
          </Box>
          <Button
            variant="contained"
            type="submit"
            onClick={handleRedirect}
            fullWidth
          >
            Log In
          </Button>
        </Grid>
        <Grid
          item
          md={6}
          sx={{
            display: { xs: 'none', md: 'block' }
          }}
        >
          <Carousel loop autoPlay interval={5000}>
            {listImages.map(item => (
              <SigninImg key={item.id} src={item.img} alt="logo" />
            ))}
          </Carousel>
        </Grid>
      </Grid>
    </Container>
  )
}
